var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "my-video" }, [_vm._t("head"), _vm._v(" "), _c('resource-list', { attrs: { "size": "large", "resources": _vm.resources, "disabled-scroll": true }, scopedSlots: _vm._u([{ key: "default", fn: function fn(_ref) {
        var resource = _ref.resource;
        return [_c('asset-card', { attrs: { "width": 136, "height": 136, "fileSrc": resource.full_url || resource.file_url, "posterSrc": resource.thumb_url, "type": 'video', "status": resource.status, "progress": resource.progress }, on: { "retry": function retry($event) {
              return _vm.retryEvent(resource.id);
            } } })];
      } }, { key: "title", fn: function fn(_ref2) {
        var resource = _ref2.resource;
        return [_c('div', { staticClass: "resource-title", attrs: { "title": resource.name } }, [_vm._v("\n        " + _vm._s(resource.name) + "\n      ")])];
      } }, { key: "add-button", fn: function fn(_ref3) {
        var resource = _ref3.resource;
        return [_vm.isAdd(resource.status) ? _c('add-resource-to-used', { attrs: { "resource": resource }, on: { "addResource": _vm.handleAddResource } }) : _vm._e()];
      } }, { key: "video-duration", fn: function fn(_ref4) {
        var resource = _ref4.resource;
        return [_c('video-duration', { attrs: { "resource": resource } })];
      } }]) })], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };